import { CountryCodes } from "../../../../types/amazonAds"
import { ProjectActionType, IProjectState, ProjectAction } from "../types/projectDataSettings"

const initialState: IProjectState = {
  projectData: {
    title: "",
    countryCode: CountryCodes.US,
    asins: [],
    keywords: [],
    campaignIds: [],
  },
  loading: false,
  error: null,
}

export const projectDataSettingsReducer = (
  state: IProjectState = initialState,
  action: ProjectAction
): IProjectState => {
  switch (action.type) {
    case ProjectActionType.FETCH_PROJECT_DATA_SETTINGS:
      return { ...state, loading: true }
    case ProjectActionType.FETCH_PROJECT_DATA_SETTINGS_SUCCESS:
      return { ...state, projectData: action.payload, loading: false }
    case ProjectActionType.FETCH_PROJECT_DATA_SETTINGS_ERROR:
      return { ...state, error: action.payload, loading: false }
    default:
      const exhaustiveCheck: never = action
      return state
  }
}

export default projectDataSettingsReducer
